import React, { useEffect, useState } from 'react';
import { Table, Icon, Message, Loader, Button, Modal, Form, Checkbox } from 'semantic-ui-react';
import { API, showSuccess, showError } from '../../helpers';

const QuotaManagement = () => {
  const [loading, setLoading] = useState(true);
  const [quotaDefs, setQuotaDefs] = useState([]);
  const [error, setError] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [editForm, setEditForm] = useState({
    name: '',
    description: '',
    unit: '',
    default_limit: 0,
    is_enabled: true
  });

  useEffect(() => {
    async function fetchQuotaDefs() {
      setLoading(true);
      setError(null);
      try {
        const res = await API.get('/api/admin/quotas/definitions');
        const data = res.data?.data || res.data || [];
        setQuotaDefs(Array.isArray(data) ? data : []);
      } catch (err) {
        setError('获取配额定义失败: ' + (err.message || '未知错误'));
      }
      setLoading(false);
    }
    fetchQuotaDefs();
  }, []);

  const handleEdit = (item) => {
    setEditingItem(item);
    setEditForm({
      name: item.name,
      description: item.description,
      unit: item.unit,
      default_limit: item.default_limit,
      is_enabled: item.is_enabled
    });
    setEditModalOpen(true);
  };

  const handleSave = async () => {
    try {
      await API.put(`/api/admin/quotas/definitions/${editingItem.id}`, editForm);
      showSuccess('配额定义更新成功');
      setEditModalOpen(false);
      // 重新加载数据
      const res = await API.get('/api/admin/quotas/definitions');
      const data = res.data?.data || res.data || [];
      setQuotaDefs(Array.isArray(data) ? data : []);
    } catch (err) {
      showError('更新失败: ' + (err.response?.data?.error || err.message || '未知错误'));
    }
  };

  const handleCancel = () => {
    setEditModalOpen(false);
    setEditingItem(null);
  };

  if (loading) return <Loader active inline='centered' content='加载中...' />;
  if (error) return <Message negative>{error}</Message>;

  return (
    <div style={{ padding: 24 }}>
      <h2><Icon name='balance scale' />配额管理</h2>
      <Table celled striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>配额Key</Table.HeaderCell>
            <Table.HeaderCell>名称</Table.HeaderCell>
            <Table.HeaderCell>描述</Table.HeaderCell>
            <Table.HeaderCell>单位</Table.HeaderCell>
            <Table.HeaderCell>默认额度</Table.HeaderCell>
            <Table.HeaderCell>是否启用</Table.HeaderCell>
            <Table.HeaderCell>操作</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {quotaDefs.map((item) => (
            <Table.Row key={item.quota_key}>
              <Table.Cell>{item.quota_key}</Table.Cell>
              <Table.Cell>{item.name}</Table.Cell>
              <Table.Cell>{item.description}</Table.Cell>
              <Table.Cell>{item.unit}</Table.Cell>
              <Table.Cell>
                {typeof item.default_limit === 'number' ? item.default_limit.toFixed(2) : item.default_limit}
              </Table.Cell>
              <Table.Cell>{item.is_enabled ? '是' : '否'}</Table.Cell>
              <Table.Cell>
                <Button size='small' onClick={() => handleEdit(item)}>编辑</Button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>

      <Modal open={editModalOpen} onClose={handleCancel} size='small'>
        <Modal.Header>编辑配额定义</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Field>
              <label>配额Key</label>
              <input value={editingItem?.quota_key || ''} disabled />
            </Form.Field>
            <Form.Field>
              <label>单位</label>
              <input value={editingItem?.unit || ''} disabled />
            </Form.Field>
            <Form.Field>
              <label>名称</label>
              <input
                value={editForm.name}
                onChange={(e) => setEditForm({ ...editForm, name: e.target.value })}
              />
            </Form.Field>
            <Form.Field>
              <label>描述</label>
              <input
                value={editForm.description}
                onChange={(e) => setEditForm({ ...editForm, description: e.target.value })}
              />
            </Form.Field>
            <Form.Field>
              <label>默认额度 ({editingItem?.unit || ''})</label>
              <input
                type='number'
                step='0.01'
                value={editForm.default_limit}
                onChange={(e) => setEditForm({ ...editForm, default_limit: parseFloat(e.target.value) || 0 })}
              />
            </Form.Field>
            <Form.Field>
              <Checkbox
                label='是否启用'
                checked={editForm.is_enabled}
                onChange={(e, { checked }) => setEditForm({ ...editForm, is_enabled: checked })}
              />
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={handleCancel}>取消</Button>
          <Button primary onClick={handleSave}>保存</Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default QuotaManagement;
